var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.616 7.885 14.394.107a.78.78 0 0 0-.788 0L.384 7.885a.777.777 0 0 0-.384.67v18.667c0 .43.348.778.778.778h7.048a.778.778 0 0 0 .775-.724c.103-1.758.58-3.474 1.402-5.031.869.583 1.875.929 2.918 1.001.178.014.354.021.528.021a5.873 5.873 0 0 0 4.264-1.769 5.688 5.688 0 0 0 1.103-3.99c-.022-1.394-.043-2.838 1.957-5.237a.778.778 0 0 0-.512-1.272c-4.83-.541-10.327 1.818-12.002 5.142a4.394 4.394 0 0 0 .589 4.965C7.911 22.746 7.191 24.12 7 26H2V9l12-7 12 7v17H11.667c-.43 0-.838.5-.838 1s.408 1 .838 1h15.555c.43 0 .778-.348.778-.778V8.556a.777.777 0 0 0-.384-.67zm-17.97 8.956c1.108-2.195 4.92-4.324 9.03-4.366a7.766 7.766 0 0 0-1.416 5.057 4.212 4.212 0 0 1-.722 2.953 4.401 4.401 0 0 1-3.497 1.21 4.493 4.493 0 0 1-2.212-.751 7.986 7.986 0 0 1 2.747-2.3.778.778 0 1 0-.696-1.392 9.47 9.47 0 0 0-3.075 2.503 2.791 2.791 0 0 1-.158-2.914z",
    fill: "#78C081"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenHouse);
export default __webpack_public_path__ + "static/media/green-house.cde96ba810286c368f4e902231f7c747.svg";
export { ForwardRef as ReactComponent };